import WatermelonSpark from 'app/assets/icons/SmartDocs/WatermelonSpark.svg'
import { Box } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'

function GetAICTA({ upgradeText = 'Get AI' }) {
  return (
    <>
      <img
        src={WatermelonSpark}
        alt="Watermelon Spark"
        width="18px"
        height="18px"
      />
      <Box ml={2} fontSize={theme.fontSizes.pRegular14}>
        {upgradeText}
      </Box>
    </>
  )
}

export default GetAICTA
